module.exports = __webpack_public_path__ + "img/sh_logo.c31334de.png";